
    <buzzyears-root [header]="false" [sidebar]="false">
      <router-outlet></router-outlet>
    </buzzyears-root>
  


// WEBPACK FOOTER //
// ./src/app/app.component.ts.AppComponent.html